module.exports = __webpack_public_path__ + "02_long_black.0a704ac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/02_long_black.png
// module id = EMcr
// module chunks = 0